/**
 * 원고 zip 다운로드 URL 조립.
 *
 * zip 은 GraphQL 이 아니라 REST 로 내려온다 — 브라우저 다운로드 내비게이션에는
 * Authorization 헤더를 실을 수 없어 mutation 이 발급한 단기 토큰을 쿼리로 붙인다.
 * API 베이스는 GraphQL 엔드포인트에서 유도해 env 를 하나 더 늘리지 않는다.
 */
const ARCHIVE_PATH = "/admin/contest/manuscripts.zip";

export function buildManuscriptArchiveUrl(
  token: string,
  graphqlEndpoint: string = import.meta.env.VITE_GRAPHQL_ENDPOINT ||
    "http://127.0.0.1:8080/graphql",
): string {
  const base = graphqlEndpoint.replace(/\/graphql\/?$/, "");
  return `${base}${ARCHIVE_PATH}?token=${encodeURIComponent(token)}`;
}

/** "12.3 MB" — 다운로드 전 용량 안내용. */
export function formatArchiveSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB"];
  let value = bytes / 1024;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[unitIndex]}`;
}
